// Utility: Cookie Handling
function getCookie (name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? match[2] : null
}

function setCookie (name, value, days = 365) {
  const expires = new Date()
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000))
  document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}`
}

/* global detectWebAuthn */

// WebAuthn Handling
function startWebAuthn (challenge, userVerification, domain) {
  detectWebAuthn(challenge, userVerification, domain)
}

// Toggle Between QR Code and Username Login
function toggleLogin () {
  document.querySelectorAll('#btn-username, #username-login, #btn-qr, #qr-code')
    .forEach(el => el.classList.toggle('d-none'))
}

function setupLoginToggle () {
  document.querySelector('#btn-qr')?.addEventListener('click', toggleLogin)
  document.querySelector('#btn-username')?.addEventListener('click', toggleLogin)
}

// Handle "Remember Auth Method" Switch
function setupRememberAuthMethod (cookieName) {
  const switchInput = document.getElementById('rememberAuthMethod')
  if (!switchInput) return

  switchInput.checked = getCookie(cookieName) !== 'false' // Default to true if cookie doesn't exist
  switchInput.addEventListener('change', () => setCookie(cookieName, switchInput.checked))
}

/* global QRCode */
/* global computeHash */

// QR Code Generation
function generateQRCode (channel, region, urlFormatQrs, appQrUrl) {
  computeHash(window.location.hostname).then((result) => {
    const qrJson = {
      app_uid: 'deprecated',
      channel: channel,
      hostname: result,
      region: region
    }

    let qrBase64 = btoa(JSON.stringify(qrJson))

    if (urlFormatQrs) {
      appQrUrl.search = qrBase64
      qrBase64 = appQrUrl.toString()
    }

    QRCode.toDataURL(qrBase64, (error, qrImageDataUrl) => {
      if (error) {
        console.error('Failed to generate QRCode!', error)
      } else {
        const qrcodeImg = document.getElementById('login_qrcode')
        qrcodeImg.setAttribute('data-content', qrBase64)
        qrcodeImg.setAttribute('src', qrImageDataUrl)
      }
    })
  }).catch(error => console.error('Failed to generate QRCode!', error))
}

/* global Faye */

// Faye Real-Time Authentication
function setupFaye (channel, tenantSlug, callbackUrl, fayeClientUrl) {
  const faye = new Faye.Client(fayeClientUrl)
  faye.subscribe(`/messages/${channel}`, () => {
    const url = `/mfa/qrcode/channel?channel=${channel}&tenant_slug=${tenantSlug}&callback_url=${callbackUrl}`
    window.location.replace(url)
  })
}

// Prevent Back Button Navigation
function preventBackNavigation () {
  history.pushState(null, null, document.URL)
  window.addEventListener('popstate', () => history.pushState(null, null, document.URL))
}

// Set User Timezone Cookie
function setTimezoneCookie () {
  setCookie('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone)
}

// Expose Functions for ERB Integration
window.LoginPage = {
  startWebAuthn,
  setupRememberAuthMethod,
  generateQRCode,
  setupFaye
}

document.addEventListener('turbolinks:load', () => {
  // Initialize Functions That Don’t Need Dynamic Params
  setupLoginToggle()
  preventBackNavigation()
  setTimezoneCookie()
})
